export enum CompType {
  CustomElement = 'wixui.CustomElementComponent',
  Flash = 'wysiwyg.viewer.components.FlashComponent',
  HTML = 'wysiwyg.viewer.components.HtmlComponent',
  StripColumnsContainer = 'wysiwyg.viewer.components.StripColumnsContainer',
  WRichText = 'wysiwyg.viewer.components.WRichText',
}
